/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Table_Display_NameInputs */

const en_users_table_display_name = /** @type {(inputs: Users_Table_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Display name`)
};

const pt_br2_users_table_display_name = /** @type {(inputs: Users_Table_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome de exibição`)
};

/**
* | output |
* | --- |
* | "Display name" |
*
* @param {Users_Table_Display_NameInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_table_display_name = /** @type {((inputs?: Users_Table_Display_NameInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Table_Display_NameInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_table_display_name(inputs)
	return pt_br2_users_table_display_name(inputs)
});